import type { FeedMappingRecord } from "../types";

export const FEED_MAPPING_STATUS_DELETED = 0;

export function isFeedMappingRowVisible(row: FeedMappingRecord): boolean {
  return row.status !== FEED_MAPPING_STATUS_DELETED;
}

export function applyFeedMappingLocalUpdate(
  rows: FeedMappingRecord[],
  id: unknown,
  params: Record<string, unknown>,
): void {
  const row = rows.find((entry) => String(entry.id) === String(id));
  if (row) Object.assign(row, params);
}

export function applyFeedMappingLocalDelete(rows: FeedMappingRecord[], id: unknown): void {
  const item = rows.find((entry) => String(entry.id) === String(id));
  if (!item) return;

  if (item.newlyAdded) {
    const idx = rows.findIndex(
      (entry) =>
        String(entry.uniqueId) === String(item.uniqueId) ||
        String(entry.feedEntityId) === String(item.feedEntityId),
    );
    if (idx !== -1) rows.splice(idx, 1);
    return;
  }

  item.status = FEED_MAPPING_STATUS_DELETED;
}
